import React from "react";
import { useTranslation } from "react-i18next";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { DialogTemplatePure, ListBoxTemplatePure,DialogChangeAdminColabRol } from "../../pures";
import cellEditCollaborators from "./cellEditCollaborators";
import DialogCollaboratorsContainer from "./dialog-collaborators";
import DialogDeleteCollaboratorPure from "../../pures/dialog-delete-collaborator/dialog-delete-collaborator.pure";
import DialogCollaboratorPure from "../dialog-loading-collaborator/dialog-loading-collaborator.pure";
import "./configuration-administrate-panel.pure.css";

/* === Custom Component for th elements of the Grid === */
const SignRequestCellHeader = (props) => {
  const cellHeaderStyles = {
    color: "#123513",
    fontSize: "14px",
    fontWeight: 600,
    display: "flex",
    justifyContent: "start",
    fontFamily: "Quicksand",
  };
  return <span style={cellHeaderStyles}>{props.title}</span>;
};

/* === Custom componente for td elements of the Grid === */
const SignRequestCell = (props) => {
  const cellItemStyles = {
    color: "#2C353C",
    fontSize: "16px",
    fontWeight: 550,
    fontFamily: "Quicksand",
  };
  return <td style={cellItemStyles}>{props.dataItem[props.field]}</td>;
};

const CompleteName = (props) => {
  const cellItemStyles = {
    color: "#2C353C",
    fontSize: "16px",
    fontWeight: 550,
    fontFamily: "Quicksand",
  };
  return (
    <td style={cellItemStyles}>
      {props.dataItem[props.field]} {props.dataItem["firstLastName"]}{" "}
      {props.dataItem["secondLastName"]}{" "}
    </td>
  );
};

const MyCustomItem = (props) => {
  let { dataItem, selected, ...others } = props;
  return (
    <li {...others}>
      <span> {props.dataItem.name} </span>
    </li>
  );
};

/* === Pure component Grid of SignatureRequestPanel === */
const ConfigurationAdministratePanelPure = (props) => {
  const { t } = useTranslation();

  const gridSignatureRequestPanelStyle = {
    height: "470px",
  };
  const gridColumnNoRecordsStyle = {
    color: "#2C353C",
    fontSize: "16px",
    fontWeight: 600,
    fontFamily: "Quicksand",
  };
  return (
    <div>
      <Grid
        className="signers"
        style={gridSignatureRequestPanelStyle}
        data={props.users.slice(props.skip, props.take + props.skip)}
        reorderable
        skip={props.skip}
        take={props.take}
        pageable={props.showPagination}
        total={props.users.length}
        onPageChange={props.onPageChange}
      >
        <GridColumn
          field="email"
          title={t("configurationAdministratePanel.email")}
          width="auto"
          cell={SignRequestCell}
          headerCell={SignRequestCellHeader}
        />
        <GridColumn
          field="firstName"
          title={t("configurationAdministratePanel.name")}
          width="auto"
          cell={CompleteName}
          headerCell={SignRequestCellHeader}
        />
        <GridColumn
          field="userTypeRole"
          title={t("configurationAdministratePanel.userType")}
          width="auto"
          cell={SignRequestCell}
          headerCell={SignRequestCellHeader}
        />
        <GridColumn
          title={t("configurationAdministratePanel.actions")}
          width="auto"
          cell={cellEditCollaborators(
            props.edit,
            props.profile,
            props.profilesBtn,
            props.remove,
            props.deleteCollaborator,
            props.isOnline
          )}
          headerCell={SignRequestCellHeader}
        />
        <GridNoRecords>
          <span style={gridColumnNoRecordsStyle}>
            {t("configurationAdministratePanel.notResults")}
          </span>
        </GridNoRecords>
      </Grid>
      {props.userInEdit && (
        <DialogCollaboratorsContainer
          {...props}
          validator={props.validator}
          validateInput={props.validateInput}
          userType={props.userType}
          dataItem={props.userInEdit}
          save={props.save}
          cancel={props.cancel}
          dialogTitle={props.dialogTitle}
          handleSubmit={props.handleSubmit}
          onSubmit={props.onSubmit}
          onDialogInputChange={props.onDialogInputChange}
          disableUserButton={props.disableUserButton}
          onChangeCombobox={props.onChangeCombobox}
          saveError={props.saveError}
          cancelError={props.cancelError}
          loadingComponent={props.loadingComponent}
          inputValidate={props.inputValidate}
        />
      )}
      {props.userProfileInEdit && (
        <DialogTemplatePure
          {...props}
          toggleDialogEditProfileUser={props.toggleDialogEditProfileUser}
          cancel={props.cancel}
          saveError={props.saveError}
          cancelError={props.cancelError}
          loadingComponent={props.loadingComponent}
          description={props.description}
          handleSubmit={props.handleSubmit}
          dataItem={props.userProfileInEdit}
          onSubmit={props.onSubmit}
          handleSubmitProfile={props.handleSubmitProfile}
          inputValidate={props.inputValidate}
        >
          <ListBoxTemplatePure
            {...props}
            titleListOne={t("configurationAdministratePanel.avaibleProfiles")}
            titleListTwo={t("configurationAdministratePanel.assignedProfiles")}
            listDataOne={props.availableProfiles}
            listDataTwo={props.assignedProfiles}
            handleItemClick={props.handleItemClick}
            handleToolBarClick={props.handleToolBarClick}
            handleDragStart={props.handleDragStart}
            handleDrop={props.handleDrop}
            loadingComponent={props.loadingComponent}
            textField="name"
            item={MyCustomItem}
          />
        </DialogTemplatePure>
      )}
      {props.visibleDialogDeleteRequest && (
        <DialogDeleteCollaboratorPure
          {...props}
          toggleDialogDeleteRequest={props.toggleDialogDeleteRequest}
          deleteCollaborator={props.deleteCollaborator}
          toggleLoadingRequesting={props.toggleLoadingRequesting}
          toggleCompletedRequesting={props.toggleCompletedRequesting}
          toggleErrorRequesting={props.toggleErrorRequesting}
          dataItem={props.userInEdit}
        />
      )}

      {/* Alerts of Notification Loadign, Completed and Error */}
      <DialogCollaboratorPure
        {...props}
        toggleCompletedRequesting={props.toggleCompletedRequesting}
        toggleErrorDomain={props.toggleErrorDomain}
        toggleErrorRequesting={props.toggleErrorRequesting}
      />

    {props.showDialogChangeAdminColab && (
      <DialogChangeAdminColabRol 
        {... props}
      />
    )}
    </div>
  );
};
export { ConfigurationAdministratePanelPure as default };
